import { Box, Button } from "@material-ui/core";
import React, { useEffect } from "react";
import ActivationLayout from "../../../components/Layout";
import { RouteComponentProps } from "@reach/router";
import { Link } from "gatsby";
import { getActivationPath } from "../../../utils/url";
import ActivationHeading from "../../../components/ActivationHeading";
import FadeInUp from "../../../../../components/animations/FadeInUp";
import CheckmarkButton from "../../../components/CheckmarkButton";
import { useConfig } from "../../../hooks/useConfig";
import ActivationFAQ from "../../../components/Faq";
import { getFullWindowMinHeight } from "../../../components/Layout/utils";
import SmallArrowIcon from "../../../../../components/icons/small-arrow";
import { scrollToAnchor } from "../../../../../helpers/browser-behavior";
import useRequireAuthenticated from "../../../hooks/useRequireAuthenticated";
import { analyticsTrackEvent } from "../../../../../services/analytics";

type Props = RouteComponentProps<{ podKeyOrSerialNumber: string }>;

export default function ActivationStep3PaymentInfo({
  podKeyOrSerialNumber
}: Props) {
  useRequireAuthenticated();
  const config = useConfig();

  const jumpToFaq = () => {
    scrollToAnchor("#faq", -50);
  };

  return (
    <ActivationLayout fullHeight>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        minHeight={{
          xs: getFullWindowMinHeight({ offset: 48, initial100vh: true }),
          sm: "0px"
        }}
      >
        <Box>
          <ActivationHeading>Almost there!</ActivationHeading>

          {[
            "Unlock your first pod with the free trial.",
            "$10 monthly fee will be charged when you unlock your second pod OR after 30 days.",
            "Cancel anytime."
          ].map((line, index) => (
            <FadeInUp key={index} yOffset={-10} delay={index}>
              <Box mt={4} display="flex">
                <CheckmarkButton
                  checked
                  marginRight={1}
                  style={{ transform: "translateY(4px)" }}
                />
                <ActivationHeading>{line}</ActivationHeading>
              </Box>
            </FadeInUp>
          ))}
        </Box>

        <Box marginTop={8}>
          {/* FAQ link */}
          <Box marginBottom={4} display="flex" justifyContent="center">
            <Button
              variant="text"
              size="small"
              startIcon={<SmallArrowIcon fontSize="small" />}
              onClick={jumpToFaq}
            >
              Why do i need a membership?
            </Button>
          </Box>

          <Button
            variant="contained"
            color="primary"
            fullWidth
            component={Link}
            to={getActivationPath(`${podKeyOrSerialNumber}/payment`)}
          >
            {"Let’s get it done"}
          </Button>
        </Box>
      </Box>

      <ActivationFAQ
        title={config.faqMembership.title}
        questionsAnswers={config.faqMembership.questionsAnswers}
        id="faq"
        mt={4}
        p={2}
        mx={-2}
        bgcolor={{ xs: "grey.300", sm: "transparent" }}
        minHeight={{ xs: "var(--100vh)", sm: "0px" }}
        mb={-1}
      />
    </ActivationLayout>
  );
}
